/**
 * Media Hero: load-in animation (background + staggered content) and scroll parallax.
 * Only runs if .media-hero exists.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const PARALLAX_STRENGTH = 15;
const LOAD = {
	bgScale: 1.12,
	bgDuration: 1,
	bgEase: "power2.out",
	overlayStartOpacity: 0.5,
	overlayDuration: 0.6,
	contentY: 28,
	contentDuration: 0.6,
	contentStagger: 0.14,
	contentEase: "power2.out",
};

export function initMediaHeroParallax() {
	const section = document.querySelector(".media-hero");
	if (!section) return;

	const bg = section.querySelector(".media-hero__bg");
	const overlay = section.querySelector(".media-hero__overlay");
	const contentItems = [
		section.querySelector(".media-hero__tag"),
		section.querySelector(".media-hero__heading"),
		section.querySelector(".media-hero__intro"),
	].filter(Boolean);

	// Load-in: overlay starts visible so bg never flashes at full brightness
	if (bg) gsap.set(bg, { scale: LOAD.bgScale, opacity: 0 });
	if (overlay) gsap.set(overlay, { opacity: LOAD.overlayStartOpacity });
	gsap.set(contentItems, { y: LOAD.contentY, opacity: 0 });

	const tl = gsap.timeline({ defaults: { ease: LOAD.bgEase } });
	if (bg) {
		tl.to(bg, {
			scale: 1,
			opacity: 1,
			duration: LOAD.bgDuration,
			ease: LOAD.bgEase,
		});
	}
	if (overlay) {
		tl.to(overlay, { opacity: 1, duration: LOAD.overlayDuration }, "-=0.5");
	}
	tl.to(
		contentItems,
		{
			y: 0,
			opacity: 1,
			duration: LOAD.contentDuration,
			stagger: LOAD.contentStagger,
			ease: LOAD.contentEase,
		},
		contentItems.length ? "-=0.35" : 0
	);

	// Parallax on scroll (only if we have a background)
	if (bg) {
		gsap.to(bg, {
			yPercent: PARALLAX_STRENGTH,
			ease: "none",
			scrollTrigger: {
				trigger: section,
				start: "top top",
				end: "bottom top",
				scrub: 0.5,
			},
		});
	}
}
